module.exports = __webpack_public_path__ + "static/media/32565383334_e54ffcd58a_o.a7638cb4.jpg";